import React from 'react';
import { Link } from 'react-router-dom';

const PublicLegalFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500 dark:text-gray-400">
        <p>© {new Date().getFullYear()} CafeLawn. All rights reserved.</p>
        <div className="flex items-center gap-4">
          <Link to="/terms" className="hover:text-gray-700 dark:hover:text-gray-200">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-gray-700 dark:hover:text-gray-200">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default PublicLegalFooter;
